import { useAppSelector } from "../../store/hooks";
import { RootState, useAppDispatch } from "../../store";
import { SharedDialogActions } from "../../store/components/sharedDialogSlice";

import Container from '@mui/material/Container';
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface IProps {
    children: any;
    isOpen?: boolean;
    data?: any;
    heading?: string;
    handleClose?: any;
    anchor?: 'bottom' | 'left' | 'right' | 'top';
    width?: number;
}

const SharedDialog = ({ children, heading = 'No heading', anchor = "right", width = 480 }: IProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useAppDispatch();
    const { open } = useAppSelector((state: RootState) => state.sharedDialog);
    const handleClose = (event: any) => {
        dispatch(SharedDialogActions.closeDialog());
    };
    return (
        <Dialog
        fullScreen={fullScreen}
        maxWidth={'lg'}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
          {heading}
          <IconButton sx={{ ml: 'auto' }} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            <Box sx={{ "padding": "0px" }}>
                {children}
            </Box>
        </DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleClose} autoFocus>
            Submit
          </Button>
        </DialogActions> */}
      </Dialog>
    );
}

export default SharedDialog;